<template>
  <div>
    <toggle-collapse>
      <DevicesListFilters :haseSupportFilter="true" :filterFor="report_type" :oldFilterData="request"
        @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
    </toggle-collapse>
    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="12">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...devices]" :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <!-- geofence  -->
          <b-col cols="6">
            <b-form-group :label="$t('Start Trip Type')">
              <v-select v-model="request.start_trip" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => $t(d.name)" :options="categoriesOptionsByGeofence" :reduce="d => d.id"
                v-on:input="filterStartTripAreas" />
              <small v-if="errors && ('start_trip' in errors)" class="text-danger">
                {{ $t(errors['start_trip'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group :label="$t('End Trip Type')">
              <v-select v-model="request.end_trip" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="categoriesOptionsByGeofence" :reduce="d => d.id" :getOptionLabel="d => $t(d.name)"
                v-on:input="filterEndTripAreas" />
              <small v-if="errors && ('end_trip' in errors)" class="text-danger">
                {{ $t(errors['end_trip'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col cols="6">

            <b-form-group :label="$t('Start Trip Areas')">
              <v-select multiple :close-on-select="false" v-model="request.start_trip_areas"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), geofence_id: 'all' }, ...geofences]" :reduce="g => g.geofence_id" />

              <small v-if="errors && ('start_trip_areas' in errors)" class="text-danger">
                {{ $t(errors['start_trip_areas'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group :label="$t('End Trip Areas')">
              <v-select multiple :close-on-select="false" v-model="request.end_trip_areas"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), geofence_id: 'all' }, ...geofencesEnd]" :reduce="g => g.geofence_id" />
              <small v-if="errors && ('end_trip_areas' in errors)" class="text-danger">
                {{ $t(errors['end_trip_areas'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col v-if="report_type == 'report'" md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type == 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type == 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('supportDevices')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData" />

    </div>

  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import reportForm from '@/app/reports/trip/reportForm'

import TripReportLogic from '@/app/reports/trip/logic'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import { ReportSetting } from '@/views/reports/ReportSettings'

import ReportOptions from '@/views/reports/components/options.js'

import DataTable from '@/views/reports/data-table/DataTable.vue'

export default {
  name: 'TripReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    ToggleCollapse,
    DataTable
  },
  directives: { Ripple, },
  props: {
    report_type: {
      type: String,
      default: 'report'
    }
  },


  setup(props, { root }) {

    const { devices } = FilterLogic()
    const divicesFilterd = (data) => {
      devices.value = data;
    }

    const { geofences, geofences_orig, geofencesEnd, categoriesOptionsByGeofence, type } = reportForm()
    const filteredGeofencesByOwner = ref([])
    const geofencesEnd_orig = ref([])
    const merageFilterWithRequest = (data) => {

      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }

      Object.assign(request.value, data);
      // refilter geof
      if (data.owners.length > 0) {
        
        filteredGeofencesByOwner.value = JSON.parse(JSON.stringify(geofences_orig.value.filter((i) => data.owners.includes(i.owner_id))))
        geofences.value = JSON.parse(JSON.stringify(filteredGeofencesByOwner.value))
        geofencesEnd.value = JSON.parse(JSON.stringify(filteredGeofencesByOwner.value))

        // console.log('filterd by owner', request.value)
        // if (request.value.end_trip !== "") { filterEndTripAreas(request.value.end_trip) }
        // if (request.value.start_trip !== "") { filterStartTripAreas(request.value.start_trip) }
        request.value.end_trip=null;
        request.value.start_trip=null;

      } else if (request.value.owners != undefined) {
        geofences.value = JSON.parse(JSON.stringify(geofences_orig.value))
        geofencesEnd.value = JSON.parse(JSON.stringify(geofences_orig.value))
        request.value.end_trip=null;
        request.value.start_trip=null;
        // console.log( 'remove owner filter',geofencesEnd.value)
        filteredGeofencesByOwner.value = JSON.parse(JSON.stringify([]))
        // if (request.value.end_trip !== "") { filterEndTripAreas(request.value.end_trip) }
        // if (request.value.start_trip !== "") { filterStartTripAreas(request.value.start_trip) }
      }

    }
    const filterEndTripAreas = (filter_category) => {

      if (filter_category != null) {
        if (filteredGeofencesByOwner.value.length > 0) {

          const result = filteredGeofencesByOwner.value.filter((i) => i.category == filter_category)
          geofencesEnd.value = JSON.parse(JSON.stringify(result))

        } else {
          const result = JSON.parse(JSON.stringify(geofences_orig.value.filter((i) => i.category == filter_category)))

          geofencesEnd.value = JSON.parse(JSON.stringify(result))
        }
      } else {
        if (request.value.owners != undefined && request.value.owners.length > 0) {
          geofencesEnd.value = JSON.parse(JSON.stringify(filteredGeofencesByOwner.value))
        } else {
          geofencesEnd.value = JSON.parse(JSON.stringify(geofences_orig.value))
        }


      }
      //console.log(geofencesEnd.value)


    }

    const filterStartTripAreas = (filter_category) => {

      if (filter_category != null) {
        if (filteredGeofencesByOwner.value.length > 0) {

          const result = filteredGeofencesByOwner.value.filter((i) => i.category == filter_category)

          geofences.value = JSON.parse(JSON.stringify(result))

        } else {
          const result = geofences_orig.value.filter((i) => i.category == filter_category)

          geofences.value = JSON.parse(JSON.stringify(result))
        }
      } else {


        if (request.value.owners != undefined && request.value.owners.length > 0) {
          geofences.value = JSON.parse(JSON.stringify(filteredGeofencesByOwner.value))
        } else {
          geofences.value = JSON.parse(JSON.stringify(geofences_orig.value))
        }
      }

      //console.log(geofences.value)


    }


    const rangeDate = ref('')
    const tableRef = ref(null)



    const { report_data, request, errors, loading, getReport, total, from, to ,isSortDirDesc,sortBy,dataTableloading} = TripReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }
    const { pickerOptions } = ReportOptions(request.value)
    const perPageOptions = [5, 10, 25, 50, 100]


    const report_wrapper = ref(null)
    const filter_included_fields = ['day', 'device', 'start_trip_area', 'end_trip_area', 'duration_string', 'trip_distance', 'start_trip_time', 'end_trip_time', 'owner', 'contract'];
    const report_fields = [
      {
        key: 'index',
        label: 'id',

      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },

      // {
      //   key: 'day',
      //   label: 'day',
      //   sortable: false
      // },
      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'start_trip_area',
        label: 'Start Trip Areas',
        sortable: false
      },
      {
        key: 'end_trip_area',
        label: 'End Trip Areas',
        sortable: false
      },
      {
        key: 'duration_string',
        label: 'duration time',
        sortable: false
      },
      {
        key: 'trip_distance',
        label: 'trip distance',
        sortable: false
      },
      {
        key: 'start_trip_time',
        label: 'Start Trip Time',
        sortable: false
      },
      {
        key: 'end_trip_time',
        label: 'End Trip Time',
        sortable: false
      },


    ]









    /// here use root form ass dialy report setting
    const toaster = (msg, variant = 'success', title = 'Success') => {
      root.$root.$bvToast.toast(
        root.$i18n.t(msg), {
        title: root.$i18n.t(title),
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster('settigs saved succeffly!!', 'success!!')
      }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {
      if (props.report_type == 'setting') {
        ReportSetting.getSetting('trip').then((res) => {

          request.value = res;
        })
      }
    })
    //here end of   dialy report setting



    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,

      devices,
      geofences,
      geofencesEnd,
      categoriesOptionsByGeofence,
      type,

      pickerOptions,
      report_wrapper,


      request,
      loading,
      errors,
      filterStartTripAreas,
      filterEndTripAreas,
      divicesFilterd,
      merageFilterWithRequest,
      //here daialy report setting
      saveDialySetting,
      sortData,
      dataTableloading

    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
